import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class UserActivation extends AManagerApi {
    protected _url: string = '/user/activation';
}
